// TS twin of iOS `WheelSize`.
// Parses backend size strings ("24x12", "20x9.5", "20").

export interface WheelSize {
  readonly diameterInches: number
  readonly widthInches: number | null
  readonly display: string
}

export function wheelSize(raw: string): WheelSize | null {
  const trimmed = raw.trim()
  if (trimmed.length === 0) return null

  const parts = trimmed.split('x', 2)
  const diameter = Number(parts[0])
  if (!Number.isFinite(diameter) || diameter <= 0) return null

  const width = parts.length > 1 ? Number(parts[1]) : NaN
  const widthInches = Number.isFinite(width) && width > 0 ? width : null

  return {
    diameterInches: diameter,
    widthInches,
    display: trimmed,
  }
}
